import area from 'utils/area';

export default {
  namespaced: true,
  state: {
      area,
  },
  getters: {
    city(state) {
        return state.area.map(_ => ({
            label: _.label,
            value: _.value
        }));
    },
    city2(state) {
      let obj = {};
        state.area.forEach(_ => {
          if (_.children) {
            obj[_.value] = _.children.map(_ => ({
              label: _.label,
              value: _.value
          }));
          }
          }
        );
        return obj;
    },
    city3(state) {
      let obj = {};
      state.area.forEach(_ => {
        _.children && _.children.forEach(item => {
          obj[item.value] =  item.children;
        })
      })
      return obj;      
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/area.js